import { createSlice } from '@reduxjs/toolkit';
import { ProviderStateType } from 'src/types/provider';

const initialState: ProviderStateType = {
    data: null,
    loading: false,
};
export const providerSlice = createSlice({
    name: 'provider',
    initialState,
    reducers: {
        initProvider: (_state, _action) => {},
        setProvider: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const { initProvider, setProvider } = providerSlice.actions;

export default providerSlice.reducer;
